// @ts-nocheck
import React, { useState, useEffect, useContext } from 'react';
import Router from 'next/router';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors } from '@/theme';
import Fetch from '@/utils/Fetch';
import ToastContext from '@/utils/toast-context';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Time from '@/utils/time';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import ProjectHistory from '@/components/project/project-history';
import CustomerContactLocationSelector from '@/components/selectors/customer/customer-contact-location-selector';
import constants from '@/utils/constants';
import StoreSelector from '@/components/selectors/store/store-selector';
import EmployeeSelector from '@/components/selectors/employee/employee-selector';
import SCTextArea from '@/components/sc-controls/form-controls/sc-textarea';
import SCDatePicker from '@/components/sc-controls/form-controls/sc-datepicker';
import {Box, Flex} from "@mantine/core";
import {useMediaQuery} from "@mantine/hooks";
import { createFileRoute } from '@tanstack/react-router'



function CreateProject() {

  const toast = useContext(ToastContext);


  const [submitting, setSubmitting] = useState(false);
  const [searching, setSearching] = useState(false);
  const [formIsDirty, setFormIsDirty] = useState(false);
  const [confirmOptions, setConfirmOptions] = useState(Helper.initialiseConfirmOptions());

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  useEffect(() => {
    getAccessStatus();
    getStore();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace, "/");
    }
  }, [accessStatus]);

  const [inputs, setInputs] = useState({
    Description: '',
    StartDate: Time.now(),
    DueDate: null,
    Budget: 0,
    IsActive: true,
  });

  const handleInputChangeSC = (e: any) => {
    setInputs({
      ...inputs,
      [e.name]: e.value
    });

    setFormIsDirty(true);
  };

  const handleInputChange = (e: any) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value
    });

    setFormIsDirty(true);
  };

  const dateChanged = (e: any, fieldName: any) => {
    setInputs({
      ...inputs,
      [fieldName]: e ? Time.toISOString(Time.updateDate(inputs[fieldName], e)) : null
    });
  };

  // STORES

  const [isMultiStore, setIsMultiStore] = useState(false);
  const [stores, setStores] = useState<any[]>([]);
  const [storesTotalResults, setStoresTotalResults] = useState<any>();
  const [storeSearch, setStoreSearch] = useState('');
  const [selectedStore, setSelectedStore] = useState<any>();

  const getStore = async () => {
    const storesResult = await Fetch.get({
      url: `/Store/GetEmployeeStores?employeeID=${Storage.getCookie(Enums.Cookie.employeeID)}&searchPhrase=`,
    });
    setIsMultiStore(storesResult.TotalResults > 1);
    if(storesResult.TotalResults === 1) {
      setSelectedStore(storesResult.Results[0] || null)
    }
  };

  useEffect(() => {
    if (selectedEmployee && !Helper.isEmptyObject(selectedEmployee)) {
      setSelectedEmployee(null);
      toast.setToast!!!({
        message: 'Employee has been cleared',
        show: true,
        type: Enums.ToastType.success
      });
    }
  }, [selectedStore]);

  const searchStores = async () => {
    setSearching(true);
    const storesResult = await Fetch.get({
      url: `/Store/GetEmployeeStores?employeeID=${Storage.getCookie(Enums.Cookie.employeeID)}&searchPhrase=${storeSearch}`,
    });
    setStores(storesResult.Results);
    setStoresTotalResults(storesResult.TotalResults);
    setSearching(false);
  };

  const handleStoreChange = (e: any) => {
    setStoreSearch(e.target.value);
    setFormIsDirty(true);
  };

  // CUSTOMERS

  const [selectedCustomer, setSelectedCustomer] = useState<any>();
  const [canChangeCustomer, setCanChangeCustomer] = useState(true);
  const [selectedCustomerName, setCustomerName] = useState('');
  const [selectedCustomerProjects, setCustomerProjects] = useState<any[]>([]);
  const [customerProjectsPage, setCustomerProjectsPage] = useState(0);
  const [canLoadMoreProjects, setCanLoadMoreProjects] = useState(true);
  const [selectedProject, setSelectedProject] = useState<any>();

  const getCustomerProjects = async (currentProjects: any, page: any) => {
    setSearching(true);

    const url = `/Project?customerID=${selectedCustomer?.ID}&pageSize=5&pageIndex=${page}`;
    const allProjects = await Fetch.get({
      url: url,
      toastCtx: toast
    });

    let newProjects = [];
    newProjects.push(...currentProjects);
    newProjects.push(...allProjects.Results);
    setCustomerProjects(newProjects);
    setSearching(false);

    if (allProjects.ReturnedResults < 5) {
      setCanLoadMoreProjects(false);
    } else if (newProjects.length == allProjects.TotalResults) {
      setCanLoadMoreProjects(false);
    }
  };

  const loadMoreProjects = () => {
    setCustomerProjectsPage(customerProjectsPage + 1);
    getCustomerProjects(selectedCustomerProjects, customerProjectsPage + 1);
  };

  const selectProject = (project: any) => {
    if (project == selectedProject) {
      setSelectedProject(undefined);
    } else {
      setSelectedProject(project);
    }
  };

  useEffect(() => {
    setCustomerProjectsPage(0);
    setCanLoadMoreProjects(true);

    if (selectedCustomer !== undefined) {
      getCustomerProjects([], 0);
    }
    setCustomerName(selectedCustomer ? selectedCustomer.CustomerName : '');
  }, [selectedCustomer]);

  // CONTACTS

  const [selectedContact, setSelectedContact] = useState<any>();

  // LOCATIONS

  const [selectedLocation, setSelectedLocation] = useState<any>();

  // EMPLOYEE

  const [selectedEmployee, setSelectedEmployee] = useState<any>();

  const assignEmployee = (employee: any) => {
    setSelectedEmployee(employee);
    setFormIsDirty(true);
  };

  const [inputErrors, setInputErrors] = useState<any>({});

  const validate = () => {

    let validationItems = [
      { key: 'Customer', value: selectedCustomer, required: true, type: Enums.ControlType.Select },
      { key: 'Contact', value: selectedContact, required: true, type: Enums.ControlType.Select },
      { key: 'StartDate', value: inputs.StartDate, required: true, type: Enums.ControlType.Date },
      { key: 'Description', value: inputs.Description, required: true, type: Enums.ControlType.Text },
      { key: 'Employee', value: selectedEmployee, required: true, type: Enums.ControlType.Custom },
      { key: 'Budget', value: inputs.Budget, gte: 0, type: Enums.ControlType.Number },
    ];

    if (isMultiStore) {
      validationItems.push({
        key: 'selectedStore', value: selectedStore, required: true, type: Enums.ControlType.Select
      });
    }

    const { isValid, errors } = Helper.validateInputs(validationItems);
    setInputErrors(errors);
    return isValid;
  }

  const submitProject = async () => {
    setSubmitting(true);
    let submitFinished = false;

    let isValid = validate();
    if (isValid) {

      let projectContactID = selectedContact ? selectedContact.ID : null;
      let projectLocationID = selectedLocation ? selectedLocation.ID : null;

      const projectPost = await Fetch.post({
        url: `/Project`,
        params: {
          StoreID: selectedStore ? selectedStore.ID : null,
          CustomerID: selectedCustomer.ID,
          CustomerContactID: projectContactID,
          LocationID: projectLocationID,
          Description: inputs.Description,
          StartDate: Time.toISOString(inputs.StartDate),
          DueDate: inputs.DueDate ? Time.toISOString(inputs.DueDate) : null,
          EmployeeID: selectedEmployee.ID,
        },
        toastCtx: toast
      });

      if (projectPost.ID) {
        toast.setToast!!!({
          message: 'Project created successfully',
          show: true,
          type: 'success'
        });
        Helper.mixpanelTrack(constants.mixPanelEvents.createProject, {
          "projectID": projectPost.ID
        });
        setFormIsDirty(false);
        await Helper.waitABit();
        Helper.nextRouter(Router.push, '/project/[id]', `/project/${projectPost.ID}`);
      } else {
        setSubmitting(false);
      }
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page',
        show: true,
        type: 'error'
      });
      setSubmitting(false);
    }

    return submitFinished;
  }

  Helper.preventRouteChange(formIsDirty, setFormIsDirty, setConfirmOptions, submitProject);

  const mobileView = useMediaQuery('(max-width: 800px)')

  return (
    <div className="manage-container">
      <div className="row">
        <div className="title">
          <Breadcrumbs currPage={{ text: 'Create Project', link: '/project/create', type: 'create' }} />
        </div>
      </div>

      <Flex w={'100%'} justify={'space-between'} align={'start'} gap={'sm'} direction={{base: 'column', lg: 'row'}}>
        <Box maw={1000} w={'100%'}>
          {isMultiStore &&
              <div className="">
                <StoreSelector
                    accessStatus={accessStatus}
                    error={inputErrors.selectedStore}
                    required={true}
                    setSelectedStore={(e: any) => {
                      setSelectedStore(e);
                      setFormIsDirty(true);
                    }}
                    selectedStore={selectedStore}
                />
                {/* <h3>Store</h3>
              <SelectInput
                changeHandler={handleStoreChange}
                error={inputErrors.selectedStore}
                label="Store name"
                options={stores}
                placeholder="Search for a store"
                required={true}
                searchFunc={searchStores}
                searching={searching}
                setSelected={setSelectedStore}
                totalOptions={storesTotalResults}
                type="store"
                value={storeSearch}
              /> */}
              </div>
          }

          <CustomerContactLocationSelector isNew={true}
                                           selectedCustomer={selectedCustomer} setSelectedCustomer={setSelectedCustomer}
                                           canChangeCustomer={canChangeCustomer}
                                           selectedContact={selectedContact} setSelectedContact={setSelectedContact}
                                           selectedLocation={selectedLocation} setSelectedLocation={setSelectedLocation}
                                           inputErrors={inputErrors} accessStatus={accessStatus} iconMode={true}
          />

          <div className="section">
            <EmployeeSelector
                accessStatus={accessStatus}
                error={inputErrors.Employee}
                required={true}
                selectedEmployee={selectedEmployee}
                setSelectedEmployee={assignEmployee}
                storeID={selectedStore?.ID ?? null}
                canClear={false}
                label={"Assigned Employee"}
                cascadeDependency={selectedStore}
            />
            {/* <h3>Assigned Employee</h3>

            <AssignEmployee selectedEmployee={selectedEmployee} setSelected={assignEmployee} error={inputErrors.Employee} storeID={(selectedStore ? selectedStore.ID : null)} /> */}
          </div>

          <div className="section">
            <h3>Project Details</h3>
            <div className="row">
              <div className='column'>
                <SCTextArea
                    error={inputErrors.Description}
                    label="Description of the project"
                    name="Description"
                    required={true}
                    value={inputs.Description}
                    onChange={handleInputChangeSC}
                />
              </div>
              {/* <TextArea
                changeHandler={handleInputChange}
                error={inputErrors.Description}
                label="Description of the project"
                name="Description"
                required={true}
                value={inputs.Description}
              /> */}
            </div>
            <div className="row">
              <div className="column">
                <SCDatePicker
                    label="Start date"
                    required={true}
                    name="StartDate"
                    changeHandler={(e: any) => dateChanged(e.value, "StartDate")}
                    value={inputs.StartDate}
                    error={inputErrors.StartDate}
                />
                {/* <KendoDatePicker
                  label="Start date"
                  required={true}
                  name="StartDate"
                  changeHandler={(e) => dateChanged(e, "StartDate")}
                  value={inputs.StartDate}
                  error={inputErrors.StartDate}
                /> */}
              </div>
            </div>
            <div className="row">
              <div className="column">
                <SCDatePicker
                    label="Due date"
                    name="DueDate"
                    changeHandler={(e: any) => dateChanged(e.value, "DueDate")}
                    value={inputs.DueDate}
                    error={inputErrors.DueDate}
                    canClear={true}
                />
                {/* <KendoDatePicker
                  label="Due date"
                  name="DueDate"
                  changeHandler={(e) => dateChanged(e, "DueDate")}
                  value={inputs.DueDate}
                  error={inputErrors.DueDate}
                /> */}
              </div>


            </div>

            <Button text="Create Project" extraClasses="fit-content" onClick={submitProject} disabled={submitting}/>
          </div>
        </Box>

        {
          !mobileView &&
            <ProjectHistory projects={selectedCustomerProjects} selectedProject={selectedProject} setSelectedProject={setSelectedProject}
                            loadMoreProjects={loadMoreProjects} canLoadMoreProjects={canLoadMoreProjects} projectSearching={searching}
                            customer={selectedCustomerName}
            />
        }

      </Flex>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 10rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .edit {
          cursor: pointer;
        }        
        .cancel-link {
          color: ${colors.bluePrimary};
          cursor: pointer;
          font-size: 0.875rem;
        }
      `}</style>
    </div>
  );
}

export default CreateProject;

export const Route = createFileRoute('/_authenticated/project/create')({ component: CreateProject })
